import Axios from "axios";

export default class TemplatesServices {
  url = process.env.REACT_APP_API;

  getFolders = () => {
    return Axios({
      method: "GET",
      url: `${this.url}/folders/templates`,
      withToken: true,
    });
  };

  setFolder = (name, parentId) => {
    const data = { name, type: "TEMPLATE" };
    if (parentId) data.parentId = parentId;
    return Axios({
      method: "POST",
      url: `${this.url}/folders`,
      data,
      withToken: true,
    });
  };

  editFolder = ({ folderId, folderName }) => {
    return Axios({
      method: "PATCH",
      url: `${this.url}/folders/${folderId}`,
      data: { name: folderName },
      withToken: true,
    });
  };

  removeFolder = (id) => {
    return Axios({
      method: "DELETE",
      url: `${this.url}/folders/${id}`,
      withToken: true,
    });
  };

  getTemplates = (id, sortQuery, search) => {
    const params = new URLSearchParams();
    if (id) params.append("folderId", id);
    if (sortQuery) params.append("sort", sortQuery);
    if (search) params.append("search", search);
    return Axios({ method: "GET", url: `${this.url}/templates?${params}`, withToken: true });
  };

  setTemplate = ({ tmplName, id, body }) => {
    return Axios({
      method: "POST",
      url: `${this.url}/templates`,
      data: {
        name: tmplName,
        body,
        folderId: id,
      },
      withToken: true,
    });
  };

  getAllTemplates = () => {
    return Axios({
      method: "GET",
      url: `${this.url}/templates`,
      withToken: true,
    });
  };

  getPreviewData = (id) => {
    return Axios({
      method: "GET",
      url: `${this.url}/screens/${id}/preview`,
    });
  };
}
